/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    label: {
        backgroundColor: "white"
    }
})

class FlexSelect extends Component {
    state = {
        value: null,
        error : false
    }

    componentWillMount () {
        this.setState({...this.state, value : this.props.instance.value.text}, () => this.setErrorAndHelperText())
    }

    getValueType = (component) => {
        switch (component) {
            // case "select" :
            //     return "text"

            default:
                return "text"
        }
    }

    getHelperText = () => {
        let helper_text
        if (this.state.error === false) {
            helper_text = this.getParam("helper_text", "text")
        } else {
            helper_text = "Invalid entry"
        }

        this.setState({...this.state, helper_text : helper_text})
    }

    setErrorAndHelperText = () => {
        let config_error = this.getParam("error", "boolean")
        let helper_text = this.getParam("helper_text", "text")
        let error_message = this.getParam("error_message", "text") !== null ? this.getParam("error_message", "text") : this.getParam("helper_text", "text")

        if (config_error !== null) {
            this.setState({...this.state, 
                error : config_error, 
                helper_text : config_error === true ? error_message : helper_text
            })
        } else {
            this.setState({
                ...this.state,
                helper_text : helper_text
            })
        }
    }

    getErrorAndHelperText = () => {
        let state_error = this.state.error

        if (state_error === true) {
            this.setState({...this.state, error : true}, () => this.getHelperText())
        }
    }

    getParam = (param_name, value_type) => {
        let parameter = null

        this.props.instance.component_params.map(param => {
            if (param.name === param_name) {
                parameter = param.value[value_type]
            }
        })

        return parameter
    }

    getOptions = () => {
        let options = this.getParam("options", "list")
        console.log('Options: ', options)

        if (options !== null) {
            let objectified_options = options.map(option => {
                if (typeof option === 'string') {
                    let object = {
                        value : option,
                        annotation : option
                    }
    
                    return object
                } else if (typeof option === 'object') {
                    return option
                }
            })
            return objectified_options
        } else {
            return []
        }
    }

    validateAndPush = () => {
        if (this.state.value !== null ) {
            this.setState({...this.state, error : false},() => {
                this.getHelperText()
                this.props.update_value(this.props.instance.id, this.getValueType(this.props.instance.component), this.state.value)
            }) 
        } else {
            this.setState({...this.state, error : true}, () => {
                this.getHelperText()
                this.props.update_value(this.props.instance.id, this.getValueType(this.props.instance.component), this.state.value)
            })
        }
    }

    handleChange = (event) => {
        this.setState({...this.state, value: event.target.value}, () => {
            this.props.update_value(this.props.instance.id, this.getValueType(this.props.instance.component), this.state.value)
            console.log("State Value: ", this.state)
        })
    }

    getAnnotation = (option) => {

    }

    render() {
        const { classes } = this.props
        return (
            <FormControl 
                style = {{width : '100%'}}
                variant = 'standard' 
                margin = 'dense'
                error = {this.state.error}
                disabled = {this.props.disabled}
            >
                <InputLabel>{this.props.instance.name}</InputLabel>
                <Select
                    value = {this.state.value}
                    onChange = {(event) => this.handleChange(event)}
                    onBlur = {this.validateAndPush}
                    label = {this.getParam("label", "text")}
                >   
                    
                    {this.getParam("allow_none", "boolean") && <MenuItem value={null}>
                        <em>--None--</em>
                    </MenuItem>}
                    {this.getOptions().map(option => {
                        return (
                            <MenuItem value = {option.value}>{option.annotation === null || option.annotation === "" ? option.value : option.annotation}</MenuItem>
                        )
                    })}
                </Select>
                <FormHelperText>{this.state.helper_text}</FormHelperText>
            </FormControl>
        );
    }
}

export default withStyles(styles)(FlexSelect);